import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  MenuItem,
  DialogActions,
  Paper,
} from "@mui/material";
import {
  getAllCampaignPromo,
  getAllPromoBatch,
} from "../../redux/actions/promocode.actions";
import { useDispatch, useSelector } from "react-redux";
import { getAllClients } from "../../redux/actions/client.actions";
import {
  getParticular,
  saveCampaignId,
} from "../../redux/actions/addCampaigndata";
import "./styles/headerdata.css";
import { Toastify } from "../../services/toastify/toastifyContainer";



const GetCampaignId = (props) => {
  const { setstepOne, setActiveStep } = props;
  const dispatch = useDispatch();
  const [errorCampaign, setErrorcampaign] = useState(false);
  const [errorClient, setErrorclient] = useState(false);
  const [updatedId,setUpdatedId] = useState("")
  const [batch, setBatch] = useState({
    client_id: "",
    campaign_id: "",
    name: "",
  });


  const { clients } = useSelector((state) => state.clientReducer);
  const { campaigns } = useSelector((state) => state.promoReducer);


  const clientsArr = clients.map((client) => ({
    id: client.client_id,
    name: client.name,
  }));

  const campaignArr = campaigns
    .filter((campaign) => campaign.client_id === batch.client_id)
    .map((campaign) => ({
      id: campaign.campaign_id,
      name: campaign.name,
    }));



  const handleInputChange = async (e) => {
    setBatch({
      ...batch,
      [e.target.name]: e.target.value,
    });

    if (e.target.name === "client_id") {
      setErrorclient(false);
    } else {
      setErrorcampaign(false);
    }
  };


  const stepperFunc = (id) => {
    dispatch(getParticular(batch.campaign_id || id)).then((res) => {
      if (res?.data?.header === true && res?.data?.body === true && res?.data?.footer === true) {
        Toastify({
          data: "success",
          msg: "This campiagn is already created..",
        });
      } else if (res?.data?.body === false && res?.data?.uiType === "external") {
        setActiveStep(1);
        setstepOne(false);
        localStorage.setItem("uiType", res?.data?.uiType)
        localStorage.setItem("campaign_type", res?.data?.campaign_type?.campaign_type)
      } else if (res?.data?.body === false && res?.data?.uiType === "plutoshome") {
        setstepOne(false);
        localStorage.setItem("uiType", res?.data?.uiType)
        setActiveStep(1);
      } else if (res?.data?.footer === false) {
        localStorage.setItem("uiType", res?.data?.uiType)
        setActiveStep(2);
        setstepOne(false);

      } else {
        dispatch(saveCampaignId(batch.campaign_id)).then((res) => {
          if (res.success === true) {
            setstepOne(false);
          }
        });
      }
    }).catch((err) => {
    });
  }


  const handleSubmit = async (e) => {
    e.preventDefault();

    const campaign_name = campaignArr.filter((filter) => batch.campaign_id === filter.id).map((item) => item.name)
    if (campaign_name === "") return Toastify({ data: "false", msg: "Please Select Your campaigns..", });
    localStorage.setItem("campaignId", batch.campaign_id);
    localStorage.setItem("campaign_name", campaign_name);
    stepperFunc();
  };

  useEffect(() => {
    dispatch(getAllPromoBatch());
    dispatch(getAllCampaignPromo());
    dispatch(getAllClients());
  }, [dispatch]);



  useEffect(() => {
    localStorage.removeItem("uiType");
    localStorage.removeItem("campaign_name");
    localStorage.removeItem("campaign_Id");
    localStorage.removeItem("campaignId");
    localStorage.removeItem("backClicked");
    localStorage.removeItem("key");
    localStorage.removeItem("campaign_type");
    localStorage.removeItem("body");
    localStorage.removeItem("againUpdate");
    setUpdatedId(localStorage.getItem('updateID'))
    if(updatedId){
      stepperFunc(updatedId);
    }
  }, [updatedId]);

  return (
    <Paper elevation={3} sx={{width:"97%"}}>
      <Box
        sx={{
          padding: "1rem",
          borderRadius: "16px",
         
        }}
      >
        <form onSubmit={handleSubmit}>
          <h2 className="text-center text-success">Select Your Campaigns</h2>
          <Box
            sx={{
              "& .MuiTextField-root": { mt: 4, ml: 7, width: "90%" },
            }}
          >
            <Grid container direction="row">
              <Grid item xs={12}>
                <TextField
                  required
                  id="client"
                  name="client_id"
                  select
                  label="Client"
                  placeholder="Select client"
                  value={clientsArr.client_id}
                  disabled={false}
                  onChange={handleInputChange}
                  className={`${errorClient ? "error" : ""}`}
                >
                  {clients.map((option) => (
                    <MenuItem key={option.client_id} value={option.client_id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  required
                  id="campaign"
                  name="campaign_id"
                  select
                  label="Campaign"
                  placeholder="Select campaign"
                  value={campaigns.campaign_id}
                  disabled={false}
                  onChange={handleInputChange}
                  className={`${errorCampaign ? "error" : ""}`}
                >
                  {campaignArr.map((option, index) => (
                    <MenuItem key={index} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  required
                  id="campaign"
                  name="campaign_id"
                  label="Campaign ID"
                  value={batch.campaign_id}
                  disabled={false}
                  onChange={handleInputChange}
                  InputProps={{
                    readOnly: true,
                  }}
                  className={`${errorCampaign ? "error" : ""}`}
                >
                  {campaignArr.map((option, index) => (
                    <MenuItem key={index} value={option.id}>
                      {option.id}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <DialogActions
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "1rem",
                }}
              >
                <Button
                  type="submit"
                  onClick={handleSubmit}
                  className="button w-25 "
                  variant="contained"
                >
                  Submit
                </Button>
              </DialogActions>
            </Grid>
          </Box>
        </form>
      </Box>
    </Paper>
  );
};

export default GetCampaignId;
